import { createFileRoute } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { MobileHome } from '@/features/home/mobile/MobileHome';
import { DesktopHome } from '@/features/home/desktop/DesktopHome';

export const Route = createFileRoute('/_app/')({ component: HomePage });

/** Selettore: Home mobile dedicata vs Home desktop. */
function HomePage() {
  const isMobile = useIsMobileShell();
  return isMobile ? <MobileHome /> : <DesktopHome />;
}
